import { PRODUCT_RATING, PRODUCT_REVIEWS } from 'elc-service-view-names';
import { Service, ServiceInitializer } from 'elc-service';
import { serviceNames, diContainer } from './diContainer';
import { RatingsReviewsServiceStartedUseCase } from '../internal/use-cases/RatingsReviewsServiceStartedUseCase';

// tslint:disable:no-var-requires no-single-line-block-comment
const packageInfo = require('../../package.json');
const { name, version } = packageInfo;

export class RatingsReviewsService extends Service {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);
        this.registerView(
            PRODUCT_RATING,
            () =>
                import(
                    /* webpackChunkName: 'ProductRating' */
                    '../exported/product-rating/ProductRating'
                ),
            // @ts-ignore
            () => diContainer.get(serviceNames.productRatingViewController)
        );
        this.registerView(
            PRODUCT_REVIEWS,
            () =>
                import(
                    /* webpackChunkName: 'ProductReviews' */
                    '../exported/product-reviews/ProductReviews'
                ),
            // @ts-ignore
            () => diContainer.get(serviceNames.productReviewsViewController)
        );
    }

    // tslint:disable-next-line:no-any
    public async start(config: any) {
        await super.start(config);

        const useCase = new RatingsReviewsServiceStartedUseCase([
            'apiKey',
            'locale',
            'merchantGroupId',
            'merchantId',
            'pageId',
            'reviewWrapperUrl',
            'reviewDisplaySnapshotType'
        ]);
        await useCase.execute();
    }
}
